import {
  useStyle 
} from "@/classify"
import defaultClasses from "./message.module.css"

const Message = (props) => {
  const {
    children, classes: propClasses, fieldState = {} 
  } = props
  const {
    error 
  } = fieldState

  const classes = useStyle(defaultClasses, propClasses)
  const className = error ? classes.root_error : classes.root

  return <p className={className}>{error || children}</p>
}

export default Message
